import React from 'react';
import './CookiePolicy.css';

const CookiePolicy = () => {
  return (
    <div className="cookie-page">
      {/* Hero Section */}
      <div className="cookie-hero">
        <div className="cookie-hero-content">
          <h1>Cookie Policy</h1>
          <p>How we use cookies to enhance your browsing experience</p>
        </div>
      </div>

      <div className="cookie-container">
        <div className="cookie-content">
          <div className="cookie-section">
            <h2>What Are Cookies?</h2>
            <p>Cookies are small text files that are placed on your device when you visit our website. They help us provide you with a better browsing experience by remembering your preferences and analyzing how you use our site.</p>
          </div>

          <div className="cookie-section">
            <h2>Types of Cookies We Use</h2>
            <div className="cookie-types">
              <div className="cookie-type">
                <h3>Essential Cookies</h3>
                <p>These cookies are necessary for the website to function properly. They enable basic functions like page navigation, access to secure areas, and shopping cart functionality.</p>
                <ul>
                  <li>Session management</li>
                  <li>Shopping cart functionality</li>
                  <li>Security features</li>
                </ul>
              </div>
              <div className="cookie-type">
                <h3>Analytics Cookies</h3>
                <p>These cookies help us understand how visitors interact with our website by collecting and reporting information anonymously.</p>
                <ul>
                  <li>Page visit statistics</li>
                  <li>User behavior analysis</li>
                  <li>Website performance metrics</li>
                </ul>
              </div>
              <div className="cookie-type">
                <h3>Functional Cookies</h3>
                <p>These cookies enable enhanced functionality and personalization, such as remembering your preferences and settings.</p>
                <ul>
                  <li>Language preferences</li>
                  <li>User preferences</li>
                  <li>Personalized content</li>
                </ul>
              </div>
              <div className="cookie-type">
                <h3>Marketing Cookies</h3>
                <p>These cookies are used to track visitors across websites to display relevant advertisements and measure the effectiveness of marketing campaigns.</p>
                <ul>
                  <li>Targeted advertising</li>
                  <li>Social media integration</li>
                  <li>Campaign effectiveness</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="cookie-section">
            <h2>How to Manage Cookies</h2>
            <div className="cookie-management">
              <div className="management-option">
                <h3>Browser Settings</h3>
                <p>You can control and manage cookies through your browser settings. Most browsers allow you to:</p>
                <ul>
                  <li>View and delete existing cookies</li>
                  <li>Block cookies from specific websites</li>
                  <li>Block all cookies</li>
                  <li>Set preferences for different types of cookies</li>
                </ul>
              </div>
              <div className="management-option">
                <h3>Cookie Consent</h3>
                <p>When you first visit our website, you'll see a cookie consent banner that allows you to:</p>
                <ul>
                  <li>Accept all cookies</li>
                  <li>Customize your cookie preferences</li>
                  <li>Reject non-essential cookies</li>
                  <li>Learn more about our cookie policy</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="cookie-section">
            <h2>Third-Party Cookies</h2>
            <p>We may use third-party services that place cookies on your device. These services help us provide better functionality and analyze website usage. Our third-party partners include:</p>
            <div className="third-party-list">
              <div className="third-party-item">
                <h4>Google Analytics</h4>
                <p>For website analytics and performance monitoring</p>
              </div>
              <div className="third-party-item">
                <h4>Social Media Platforms</h4>
                <p>For social media integration and sharing features</p>
              </div>
              <div className="third-party-item">
                <h4>Payment Processors</h4>
                <p>For secure payment processing and fraud prevention</p>
              </div>
            </div>
          </div>

          <div className="cookie-section">
            <h2>Cookie Retention</h2>
            <div className="retention-info">
              <div className="retention-card">
                <h3>Session Cookies</h3>
                <p>These cookies are deleted when you close your browser and are used for temporary session management.</p>
              </div>
              <div className="retention-card">
                <h3>Persistent Cookies</h3>
                <p>These cookies remain on your device for a specified period (usually 1-2 years) unless you delete them manually.</p>
              </div>
            </div>
          </div>

          <div className="cookie-section">
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul className="rights-list">
              <li>Accept or decline cookies</li>
              <li>Delete existing cookies from your device</li>
              <li>Set browser preferences to block certain types of cookies</li>
              <li>Request information about the cookies we use</li>
              <li>Withdraw consent for non-essential cookies at any time</li>
            </ul>
          </div>

          <div className="cookie-section">
            <h2>Updates to This Policy</h2>
            <p>We may update this Cookie Policy from time to time to reflect changes in our practices or for legal reasons. We will notify you of any material changes by posting the updated policy on this page.</p>
            <p><strong>Last Updated:</strong> January 2024</p>
          </div>

          <div className="cookie-section">
            <h2>Contact Us</h2>
            <p>If you have any questions about our Cookie Policy or how we use cookies, please contact us:</p>
            <div className="contact-info">
              <p><strong>Email:</strong> privacy@inifiy.com</p>
              <p><strong>Address:</strong> 123 E-commerce Street, Digital City, DC 12345</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookiePolicy; 